import { Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CircularProgress from '@mui/material/CircularProgress';
import { useForm } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { NumberInput } from '../NumberInput';
import { style } from '../../../helpers/editStyle';
import { DateInput } from '../DateInput';
import { unSelectDivestmentClub } from '../../../store/divestmentClub/divestmentClubSlice';
import { fetchData } from '../../helpers/getData/fetchData';
import { editDivestment } from '../../helpers/divestment';

export const EditDivestmentClub = ({ setHidden, setDivestmentData}) => {

    const { t } = useTranslation('global');
    const [sharesInvestment, setSharesInvestment] = useState('isLoading')
    const { dataToAction } = useSelector(state => state.divestmentClub)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);

    const { divestmentDate, divestmentParticipation, salesPrice } = formValues;

    const handleCancel = () => {
        reset()
        dispatch(unSelectDivestmentClub())
        setHidden(false)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        setHidden(false)
        const investmentAmount = ((dataToAction.divestmentParticipation + sharesInvestment) - divestmentParticipation) * dataToAction.participationValuation
        await editDivestment({ divestmentDate, divestmentParticipation, salesPrice, investmentId: dataToAction.investmentId, investmentAmount, id: dataToAction.id }, t('divestment.successEditMsg'), t('divestment.errorMsg') )
        setDivestmentData(null)
    }

    useEffect(() => {
        fetchData(setSharesInvestment, `/investments/getSharesAmount?investment=${dataToAction.investmentId}`, t)
    }, [t, dataToAction.investmentId])

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            {
                sharesInvestment !== 'isLoading' ?
                    <Box sx={style}>
                        <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                            <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('divestment.edit')}</Typography>
                            <IconButton color='primary' onClick={handleCancel}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </Stack>
                        <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                            <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                                <Stack direction='column' width='100%' gap={0}>
                                    <DateInput name={divestmentDate} title='divestmentDate' handleInputChange={handleInputChange} translation='divestmentDate' required={true} />
                                </Stack>

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <Typography variant='overline' color='secondary'>{t(`number.divestmentParticipation`)}</Typography>
                                        <TextField
                                            fullWidth
                                            name='divestmentParticipation'
                                            size="small"
                                            variant="outlined"
                                            value={divestmentParticipation}
                                            onChange={handleInputChange}
                                            required={true}
                                            type='number'
                                            InputProps={{ inputProps: { min: 0, step: 'any', max: (dataToAction.divestmentParticipation + sharesInvestment) } }}
                                            label={`${(dataToAction.divestmentParticipation
                                                + sharesInvestment) } ${t('divestment.available')}`}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} padding='0 5px'>
                                        <NumberInput translation='salesPrice' name={salesPrice} title='salesPrice' handleInputChange={handleInputChange} required={true} />
                                    </Grid>
                                </Grid>

                            </Stack>

                            <Stack sx={{ heigth: '80px' }}>
                                <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                                <Grid container direction='row' width='100%' >
                                    <Grid item xs={12} md={6} padding='0 5px'>
                                        <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                                    </Grid>
                                    <Grid item xs={12} md={6} padding='0 5px'>
                                        <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </form>

                    </Box>
                    :
                    <Stack width='100%' alignItems='center' marginTop='100px'>
                        <CircularProgress />
                    </Stack>
            }
        </Modal>
    )
}